import React, { Component } from 'react'
import ReactMarkdown from "react-markdown"


import {Link} from 'gatsby'
import BackgroundImage from 'gatsby-background-image'
import LinkedIn from "../images/linkedin.svg"



class ProjectGrid extends Component {
  constructor(props) {
    super(props)

    this.returnImage = this.returnImage.bind(this)

    this.layoutContents = React.createRef()
  }

  returnImage(image){
if(image !== null){
    return ([
image.childImageSharp.fluid,
`linear-gradient(${this.props.data.TileBackgroundColor}, ${this.props.data.TileBordercolor})`
].reverse()
)
}else{
  return ([
`linear-gradient(${this.props.data.TileBackgroundColor}, ${this.props.data.TileBordercolor})`
].reverse()
)
}
  }

  render() {





    return (

      <li className="slice__item list__item row__item row__item--span-1">

          <div className="item itemEnlarge item--has-image item_title_bottom contact">
    <BackgroundImage Tag="div" className="item__container" fluid={this.returnImage(this.props.data.image)}>

                  <div className="item__media">

                  </div>
                  <div className="item__content">
                      <div className="item__header">
                          <h3 className="item__title" style={{color:this.props.data.TileTextColor}}>
                              <a className="item__link" href="#">
                                  {this.props.data.title}
                              </a>
                          </h3>
                      </div>
                      <div className="item__teaser">
                      {this.props.data.author}
                      </div>

                  </div>
                      <a href={this.props.data.slug} target="_blank"><img className="linkedinicon" src={LinkedIn}/></a>
                  <a href={`mailto:${this.props.data.sub_message}`} className="block-link-overlay">

                  </a>
                            </BackgroundImage>
              </div>

      </li>


    )


}
}

export default ProjectGrid;
